<template>
<div class="table-mapa-financeiro">
 <div class="circle-plus closed">
  <div class="circle">
    <div class="horizontal"></div>
    <div class="vertical"></div>
  </div>
</div>
  <table class="w3-table w3-striped w3-bordered w3-hide-small w3-hide-medium  w3-col">
    <tr style="background: #f1f1f1">
      <th><strong>Vencimento</strong></th>
      <th  style="text-align: right"><strong>Saldo inicial</strong></th>
      <th  style="text-align: right"><strong>Contas a receber</strong></th>
      <th  style="text-align: right"><strong>Previsões de venda</strong></th>
      <th  style="text-align: right"><strong>Contas a pagar</strong></th>
      <th  style="text-align: right"><strong>Previsões a pagar</strong></th>
      <th  style="text-align: right"><strong>Saldo no final do dia</strong></th>
    </tr>
    <tbody v-for="(dados, index) in mapa_financeiro_dados" :key="index">
      <tr v-if="dados.mostrar" @click="toogleCard(dados, false)" class="tr-items tr-items-ativo" v-bind:class="{negativo: (formatarValor(dados.saldo_final, 2) < 0)}">
        <td>{{ dados.data_vencimento }}</td>
        <td  style="text-align: right"><strong>R$ {{ formatarValor(dados.saldo_inicial, 2) }}</strong></td>
        <td  style="text-align: right">R$ {{ formatarValor(dados.total_a_receber, 2) }}</td>
        <td  style="text-align: right">R$ {{ dados.previsoes_venda }}</td>
        <td  style="text-align: right">R$ {{ formatarValor(dados.soma_contas_pagar, 2) }}</td>
        <td  style="text-align: right">R$ {{ formatarValor(dados.soma_previsoes_pagar, 2) }}</td>
        <td  style="text-align: right"><strong>R$ {{ formatarValor(dados.saldo_final, 2) }}</strong></td>
      </tr>
      <tr v-if="!dados.mostrar" @click="toogleCard(dados, true)" class="tr-items" v-bind:class="{negativo: (dados.saldo_final < 0)}">
        <td class="td-items">{{ dados.data_vencimento }}</td>
        <td class="td-items" style="text-align: right"><strong>R$ {{ formatarValor(dados.saldo_inicial, 2) }}</strong></td>
        <td class="td-items" style="text-align: right">R$ {{ formatarValor(dados.total_a_receber, 2) }}</td>
        <td class="td-items" style="text-align: right">R$ {{ dados.previsoes_venda }}</td>
        <td class="td-items" style="text-align: right">R$ {{ formatarValor(dados.soma_contas_pagar, 2) }}</td>
        <td class="td-items" style="text-align: right">R$ {{ formatarValor(dados.soma_previsoes_pagar, 2) }}</td>
        <td class="td-items" style="text-align: right"><strong>R$ {{ formatarValor(dados.saldo_final, 2) }}</strong></td>
      </tr>
        <transition name="fade" mode="out-in">
          <tr v-if="dados.mostrar">
            <td class="mapa-financeiro-card" colspan="7" >
              <mapa-financeiro-card :dados="dados" />
            </td>
          </tr>
        </transition>
    </tbody>
  </table>
  <div class="w3-hide-large card-informacoes" :class="{'card-ativo': dados.mostrar}" v-for="(dados, index) in mapa_financeiro_dados" :key="index" @click="toogleCard(dados, !dados.mostrar)">
    <div class="w3-col s12">
      <strong>Vencimento</strong>
      <label class="w3-right">{{ dados.data_vencimento }}</label>
    </div>
    <div class="w3-col s12">
      <strong>Saldo inicial</strong>
      <label class="w3-right">R$ {{ formatarValor(dados.saldo_inicial, 2) }}</label>
    </div>
    <div class="w3-col s12">
      <strong>Contas a receber</strong>
      <label class="w3-right">R$ {{ formatarValor(dados.total_a_receber, 2) }}</label>
    </div>
    <div class="w3-col s12">
      <strong>Previsões de venda</strong>
      <label class="w3-right">R$ {{ dados.previsoes_venda }}</label>
    </div>
    <div class="w3-col s12">
      <strong>Contas a pagar</strong>
      <label class="w3-right">R$ {{ formatarValor(dados.soma_contas_pagar, 2) }}</label>
    </div>
    <div class="w3-col s12">
      <strong>Previsões a pagar</strong>
      <label class="w3-right">R$ {{ formatarValor(dados.soma_previsoes_pagar, 2) }}</label>
    </div>
    <div class="w3-col s12">
      <strong>Saldo no final do dia</strong>
      <label class="w3-right"><strong>R$ {{ formatarValor(dados.saldo_final, 2) }}</strong></label>
    </div>
      <transition name="fade" mode="out-in">
        <tr v-if="dados.mostrar">
          <td class="mapa-financeiro-card" colspan="7" >
              <mapa-financeiro-card  :dados="dados"></mapa-financeiro-card>
          </td>
        </tr>
      </transition>
  </div>
</div>
</template>

<script>
import formatarValorMixin from '@/mixins/formatarValorMixin.js'
import MapaFinanceiroCard from '@/components/MapaFinanceiroCard'

export default {
  name: 'MapaFinanceiroSintetico',
  props: ['mapa_financeiro_dados'],
  mixins:[formatarValorMixin],
  components: {
    MapaFinanceiroCard
  },
  data() {
    return {
    }
  },
  methods: {
    toogleCard(index, condicional) {
      this.$set(index, 'mostrar', condicional)
    }
  },
}
</script>

<style scoped>
  .card-informacoes {
    margin-bottom: 10px;
    border-left-style: solid;
    border-left-color: #636363 !important;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    float: left;
    padding: 7px;
    border-bottom-color: #636363 !important;
  }
  .negativo {
    color: #9c1d1c
  }
  .w3-card {
    padding: 15px 20px
  }

  .chip-vencimento {
    border-radius: 25px;
    font-size: .9em;
    padding: 10px 15px;
    display: inline-block;
  }
  .td-items {
    white-space: nowrap;
    padding-bottom: 15px;
    padding-top: 15px;
  }

  tr{
    transition: 0.3s;
  }
  .tr-items:hover {
    background: #9c1d1c;
    color:#fff;
    cursor: pointer;
  }
  .table-mapa-financeiro {
    overflow: auto;
  }
  th {
    white-space: nowrap;
  }
  .mapa-financeiro-card {
    padding: 0 !important
  }
  .fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .tr-items-ativo {
    background: #9c1d1c;
    color: white;
  }
  .tr-items-ativo:hover {
    background: #9c1d1cb8;
    color: white;
  }
  .card-ativo {
    background: #d4d4d4
  }
  .w3-container {
    white-space: normal !important;
  }
   
</style>


// WEBPACK FOOTER //
// src/components/MapaFinanceiroSintetico.vue